<article
  *ngIf="item"
  class="core-ui-media-hover-preview"
  role="tooltip"
  [id]="panelId"
>
  <img
    *ngIf="previewUrl as imageUrl; else mediaFallback"
    class="core-ui-media-hover-preview__media"
    [src]="imageUrl"
    alt=""
  />

  <ng-template #mediaFallback>
    <div class="core-ui-media-hover-preview__media core-ui-media-hover-preview__fallback">
      {{ metadata }}
    </div>
  </ng-template>

  <div class="core-ui-media-hover-preview__content">
    <strong>{{ item.name }}</strong>
    <span>{{ metadata }}</span>
  </div>
</article>
